import { render, staticRenderFns } from "./CompanyServicesTax.vue?vue&type=template&id=153bdaec&"
import script from "./CompanyServicesTax.vue?vue&type=script&lang=js&"
export * from "./CompanyServicesTax.vue?vue&type=script&lang=js&"
import style0 from "./CompanyServicesTax.vue?vue&type=style&index=0&id=153bdaec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports